<div class="d-flex flex-row gap-24 h-100">
  <!--------------  PRICE FILTER -------------->
  <div class="position-relative d-none d-lg-block" *ngIf="!isMobile">

    <button
      (click)="$event.stopPropagation();openFilter('price')"
      (blur)="isPriceFocus= false"
      (focus)="isPriceFocus= true"
      (keypress.enter)="openFilter('price')"
      [ngClass]="{'text-white bg-actif': isPriceFocus || displayedFilter === 'price' || (filters['minPrice'] > priceSliderOptions.floor || (filters['maxPrice'] && filters['maxPrice'] !== priceSliderOptions.ceil))}"
      class="btn py-3 d-sm-flex align-items-center text_2 text-nowrap br-10">

      <div *ngIf="filters['minPrice'] <= priceSliderOptions.floor && (!filters['maxPrice'] || filters['maxPrice'] === priceSliderOptions.ceil) ; else priceBlock">
        {{ "PROCESSES.ACCOMMODATION.LIST.PRICE_RANGE" | translate }}
      </div>

      <ng-template #priceBlock>
        {{ (filters['minPrice'] ? filters['minPrice'] : 0) + " - " + (filters['maxPrice'] ? filters['maxPrice'] : priceSliderOptions.ceil) }}
      </ng-template>


      <lf-icon
        [fillColor]="(filters['minPrice'] > priceSliderOptions.floor || (filters['maxPrice'] && filters['maxPrice'] !== priceSliderOptions.ceil)) || displayedFilter === 'price' || isPriceFocus ? 'white' : 'black'"
        class="ms-2 lh-1" height="16px" name="euroSymbol"
        width="16px"></lf-icon>
    </button>

    <div #miniModale *ngIf="displayedFilter === 'price'"
      class="position-absolute d-flex flex-column gap-24 box-shadow isInside br-10">
      <div class="text_4 position-absolute d-flex justify-content-between">
        <div class="isInside text-start">
          <div class="minitext_3 fst-italic isInside lh-1">{{priceSliderOptions.floor + ' €'}}</div>
          -
        </div>
        <div class="isInside text-end">
          <div class="minitext_3 fst-italic isInside lh-1">{{priceSliderOptions.ceil + ' €'}}</div>
          +
        </div>
      </div>

      <ngx-slider (userChangeEnd)="updateFromSlider('price',$event)"
        class="m-0 isInside"
        [(value)]="slider.price.min"
        [(highValue)]="slider.price.max"
        [options]="priceSliderOptions"></ngx-slider>

      <div class="gap-16 d-flex flex-column mt-2 isInside">
        <div class="form_inputs px-2 py-1 d-flex isInside br-10 bg-white">
          <input numberOnly class="w-100 border-0 minitext_3 isInside" min="0"
            [(ngModel)]="filters.minPrice" (ngModelChange)="updateFromInputs('price', 'min', $event)"
            placeholder="{{'COMMON.MINIMUM' | translate}}" size="5" type="number">
          <div class="input-prefix text_2 ps-2 pe-1 isInside">€</div>
        </div>
        <div class="form_inputs px-2 py-1 d-flex isInside br-10 bg-white">
          <input numberOnly class="w-100 border-0 minitext_3 isInside" [min]="(slider.price.min ? slider.price.min : priceSliderOptions.floor) + 1"
            [(ngModel)]="filters.maxPrice" (ngModelChange)="updateFromInputs('price', 'max', $event)"
            placeholder="{{'COMMON.MAXIMUM' | translate}}" size="5" type="number">
          <div class="input-prefix text_2 ps-2 pe-1 isInside">€</div>
        </div>
      </div>

      <button role="button" class="isInside btn btn-link border-0 p-0 m-0 w-fit-content txt-darkGray" type="reset" (click)="clearQuickFilter('Price')">
        {{ 'PROCESSES.ACCOMMODATION.LIST.FILTER_CLEAR' | translate }}
      </button>

    </div>

  </div>


  <!--------------  SURFACE FILTER -------------->
  <div class="position-relative  d-none d-lg-block" *ngIf="!isMobile">
    <button
      (click)="$event.stopPropagation();openFilter('meter')"
      (blur)="isSurfaceFocus= false"
      (focus)="isSurfaceFocus= true"
      (keypress.enter)="openFilter('meter')"
      [ngClass]="{'text-white bg-actif': isSurfaceFocus || displayedFilter === 'meter' || (filters['minMeter'] > meterSliderOptions.floor || (filters['maxMeter'] && filters['maxMeter'] !== meterSliderOptions.ceil))}"
      class="btn py-3 d-sm-flex align-items-center text_2 text-nowrap br-10">

      <div
        *ngIf="filters['minMeter'] <= meterSliderOptions.floor && (!filters['maxMeter'] || filters['maxMeter'] === meterSliderOptions.ceil) ; else meterBlock">
        {{ "PROCESSES.ACCOMMODATION.SURFACE" | translate }}
      </div>

      <ng-template #meterBlock>
        {{ (filters['minMeter'] ? filters['minMeter'] : 0) + " - " + (filters['maxMeter'] ? filters['maxMeter'] : meterSliderOptions.ceil) }} {{" m²"}}
      </ng-template>


      <lf-icon
        [fillColor]="(filters['minMeter'] > meterSliderOptions.floor || (filters['maxMeter'] && filters['maxMeter'] !== meterSliderOptions.ceil)) || displayedFilter === 'meter' || isSurfaceFocus ? 'white' : 'black'"
        class="ms-2 lh-1" height="16px" name="surface"
        width="16px"></lf-icon>
    </button>

    <div #miniModale *ngIf="displayedFilter === 'meter'"
      class="position-absolute d-flex flex-column gap-24 box-shadow isInside meterbox br-10">
      <div class="text_4 position-absolute d-flex justify-content-between isInside">
        <div class="isInside text-start">
          -
        </div>
        <div class="isInside text-end">
          +
        </div>
      </div>

      <ngx-slider (userChangeEnd)="updateFromSlider('meter',$event)"
        class="m-0 isInside"
        [(value)]="slider.meter.min"
        [(highValue)]="slider.meter.max"
        [options]="meterSliderOptions"></ngx-slider>

      <div class="gap-16 d-flex flex-column mt-2 isInside">
        <div class="form_inputs px-2 py-1 d-flex isInside br-10 bg-white">
          <input numberOnly class="w-100 border-0 minitext_3 isInside" min="0"
            [(ngModel)]="filters.minMeter" (ngModelChange)="updateFromInputs('meter', 'min', $event)"
            placeholder="{{'COMMON.MINIMUM' | translate}}" size="5" type="number">
          <div class="input-prefix text_2 ps-2 isInside">m²</div>
        </div>
        <div class="form_inputs px-2 py-1 d-flex isInside br-10 bg-white">
          <input numberOnly class="w-100 border-0 minitext_3 isInside" [min]="(slider.meter.min ? slider.meter.min : meterSliderOptions.floor) + 1"
            [(ngModel)]="filters.maxMeter" (ngModelChange)="updateFromInputs('meter', 'max', $event)"
            placeholder="{{'COMMON.MAXIMUM' | translate}}" size="5" type="number">
          <div class="input-prefix text_2 ps-2 isInside">m²</div>
        </div>
      </div>

      <button class="btn btn-link border-0 p-0 m-0 w-fit-content txt-darkGray isInside" type="button" (click)="clearQuickFilter('Meter')">
        {{ 'PROCESSES.ACCOMMODATION.LIST.FILTER_CLEAR' | translate }}
      </button>

    </div>
  </div>

  <!--------------  BOUTON FILTER MODAL DESKTOP -------------->
  <button (click)="openModal(filterModal)"
    (blur)="isGeneralFocus= false"
    (focus)="isGeneralFocus= true"
    [ngClass]="{'custom-btn-padding': isMobile, 'active': nbSubFilter !== 0}"
    class="btn py-3 d-sm-flex align-items-center text_2 text-nowrap br-10">
    <span class="d-none d-lg-block" *ngIf="!isMobile">
      {{ 'COMMON.FILTER.TITLE' | translate}}
    </span>
    <lf-icon class="lh-1 ms-lg-2" [fillColor]="isGeneralFocus || nbSubFilter !== 0 ? 'white' : 'black'" height="16px"
      name="filter"
      width="16px"></lf-icon>
  </button>

</div>

<ng-template #filterModal>

  <!--------------------------------------------- MODALE --------------------------------------------------------------->
  <div [ngClass]="{'pt-0':isMobile}" class="modale_filters">
    <div class="row container-fluid p-0 m-0 h-fit-content p-3">
      <div id="js-scrollDown"  class="bg-white br-10 overflow-auto hidden-scrollbar flex-grow-1">

        <div class="d-flex flex-row justify-content-between align-items-center mb-3 pb-2 border-bottom">
          <h2 class="title_1 mb-0"> {{ 'COMMON.FILTER.TITLE' | translate}} </h2>
          <button (click)="closeModale()" aria-label="Close" class="btn border-0 m-0 ms-auto p-0" type="button">
            <span class="material-icons-outlined text-black">close</span>
          </button>
        </div>

        <div class="modale_body position-relative">
          <app-filter-content [rangeLimits]="rangeLimit" (sendNewFilters)="filters = $event; filterRooms()" [filters]="filters"></app-filter-content>


          <h6 class="text_4 mb-4 d-flex d-lg-none align-items-center mt-4 border-top pt-4 mb-4">
            {{ "PROCESSES.ACCOMMODATION.LIST.SORT_TITLE" | translate }}
          </h6>
          <mat-radio-group [(ngModel)]="sortValue" class="d-flex d-lg-none gap-16 flex-wrap mb-5">
            <mat-radio-button *ngFor="let value of sortArray" (click)="updateSort(value.name)"
              [ngClass]="{'fw-bold' : sortValue == value.name}" class="text_2" value="{{value.name}}">
              {{ "PROCESSES.ACCOMMODATION.LIST." + value.key | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <app-show-more></app-show-more>

      </div>
      <!-- BOUTONS -->
      <div class="sticky-bottom pt-3 d-flex gap-16 bg-white justify-content-center w-100">
        <button (click)="clearFilter()" class="btn pointer text_3 btn-link mediumGray border-0">
          {{ 'COMMON.CLEAR' | translate }}
        </button>
        <button (click)="submit();closeModale()" class="btn bg-actif title_3 px-4 text-white">
          {{ 'PROCESSES.ACCOMMODATION.LIST.FILTER_SUBMIT' | translate:{value: filteredRoomsArray.length} }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
